<template>
  <b-modal
    id="tabel-dinamis-fields-layouting-modal"
    hide-footer
    header-class="td-bg-blue text-white"
    scrollable
  >
    <template #modal-title>
      <b-icon icon="puzzle-fill" /> Fields Layouting
    </template>

    <b-card no-body>
      <b-card-header class="td-bg-blue text-light font-weight-bold">
        <b-icon icon="layout-three-columns" />
        Baris
      </b-card-header>

      <b-card-body
        id="tabel-dinamis-dropzone-row-item"
        @drop="onDrop($event)"
        @dragover.prevent
        @dragenter.prevent
      >
        <div
          :id="'tabel-dinamis-item-fields-' + item"
          class="td-border-grey td-border-solid td-border-thin td-cursor-move py-2 px-3 mt-2 draggable-fields"
          v-for="(item, idx) in choosenRowFields"
          :key="idx"
          :data-value="item"
          draggable
          @dragstart="startDrag($event)"
        >
          <b-icon class="mr-1 td-text-grey" icon="grid-fill" font-scale="0.8" />
          <template v-if="item === 'indicator'"> Indikator </template>
          <template v-else-if="item === 'region'"> Wilayah </template>
          <template v-else-if="item === 'period'"> Periode </template>

          <template v-else-if="item.startsWith('category')">
            {{
              choosenDimensions[item].name
                .split(" ")
                .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
                .join(" ")
            }}
          </template>
        </div>
      </b-card-body>
    </b-card>

    <b-card no-body class="mt-4">
      <b-card-header class="td-bg-blue text-light font-weight-bold">
        <b-icon icon="layout-three-columns" rotate="90" />
        Kolom
      </b-card-header>

      <b-card-body
        id="tabel-dinamis-dropzone-column-item"
        @drop="onDrop($event)"
        @dragover.prevent
        @dragenter.prevent
      >
        <div
          :id="'tabel-dinamis-item-fields-' + item"
          class="td-border-grey td-border-solid td-border-thin td-cursor-move py-2 px-3 mt-2 draggable-fields"
          v-for="(item, idx) in choosenColumnFields"
          :key="idx"
          :data-value="item"
          draggable
          @dragstart="startDrag($event)"
        >
          <b-icon class="mr-1 td-text-grey" icon="grid-fill" font-scale="0.8" />
          <template v-if="item === 'indicator'"> Indikator </template>
          <template v-else-if="item === 'region'"> Wilayah </template>
          <template v-else-if="item === 'period'"> Periode </template>

          <template v-else-if="item.startsWith('category')">
            {{
              choosenDimensions[item].name
                .split(" ")
                .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
                .join(" ")
            }}
          </template>
        </div>
      </b-card-body>
    </b-card>

    <b-row class="mt-4 mb-3" align-h="center">
      <b-button
        class="td-btn td-btn-outline-red mr-1"
        @click="cancelUpdateLayouting"
      >
        <b-icon icon="x-circle" />
        Batal Ubah
      </b-button>
      <b-button class="td-btn td-btn-blue ml-1" @click="updateLayouting">
        <b-icon icon="check-circle" />
        Simpan Layout
      </b-button>
    </b-row>
  </b-modal>
</template>

<!-- javascript section-->
<script>
//import js modules section
import utils from "../../../../../../../../utils/TabelDinamisUtils";

//local registration for output component
export default {
  name: "VisualizationFieldsLayoutingModal",
  data() {
    return {
      moving: null,
    };
  },
  props: [
    "choosenRowFields",
    "choosenColumnFields",
    "choosenDimensions",
    "updateIsNeedReloaded",
    "updateChoosenRowFields",
    "updateChoosenColumnFields",
  ],
  created() {},
  destroyed() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    startDrag(evt) {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("item", evt.target.id);
    },
    onDrop(evt) {
      evt.preventDefault();
      let item = evt.dataTransfer.getData("item");

      if (
        evt.target.id === "tabel-dinamis-dropzone-column-item" ||
        evt.target.id === "tabel-dinamis-dropzone-row-item"
      ) {
        document
          .getElementById(evt.target.id)
          .appendChild(document.getElementById(item));
      } else {
        if (evt.target.id !== item) {
          if (
            evt.currentTarget.id !== document.getElementById(item).parentNode.id
          ) {
            document
              .getElementById(evt.currentTarget.id)
              .insertBefore(
                document.getElementById(item),
                document.getElementById(evt.target.id)
              );
          } else {
            let childrenNodesKolomBarisDropzone = document.getElementById(
              evt.currentTarget.id
            ).children;

            let idxItem = Array.from(childrenNodesKolomBarisDropzone).indexOf(
              document.getElementById(item)
            );

            let idxTargetId = Array.from(
              childrenNodesKolomBarisDropzone
            ).indexOf(document.getElementById(evt.target.id));

            if (idxItem < idxTargetId) {
              if (idxTargetId === childrenNodesKolomBarisDropzone.length - 1) {
                document
                  .getElementById(evt.currentTarget.id)
                  .insertBefore(document.getElementById(item), null);
              } else {
                document
                  .getElementById(evt.currentTarget.id)
                  .insertBefore(
                    document.getElementById(item),
                    document.getElementById(
                      childrenNodesKolomBarisDropzone[idxTargetId + 1].id
                    )
                  );
              }
            } else {
              document
                .getElementById(evt.currentTarget.id)
                .insertBefore(
                  document.getElementById(item),
                  document.getElementById(
                    childrenNodesKolomBarisDropzone[idxTargetId].id
                  )
                );
            }
          }
        }
      }
    },
    cancelUpdateLayouting() {
      this.$bvModal.hide("tabel-dinamis-fields-layouting-modal");
    },
    updateLayouting() {
      this.cancelUpdateLayouting();

      let tempColumnFields = [];
      let tempRowFields = [];

      let columnDropzoneItems = document.getElementById(
        "tabel-dinamis-dropzone-column-item"
      ).children;
      let rowDropzoneItems = document.getElementById(
        "tabel-dinamis-dropzone-row-item"
      ).children;

      tempColumnFields = Object.values(columnDropzoneItems).map((item) => {
        return item.getAttribute("data-value");
      });

      tempRowFields = Object.values(rowDropzoneItems).map((item) => {
        return item.getAttribute("data-value");
      });

      if (
        !utils.arraysEqual(tempRowFields, this.choosenRowFields) ||
        !utils.arraysEqual(tempColumnFields, this.choosenColumnFields)
      ) {
        this.updateChoosenRowFields(tempRowFields);
        this.updateChoosenColumnFields(tempColumnFields);

        this.updateIsNeedReloaded(true);
      }
    },
  },
  components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";

.draggable-fields:active {
  background: #d3d3d3;
  color: white;
  font-weight: bolder;
}
</style>

<!-- author: m.	nif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 27-09-2022 -->
